export default __webpack_public_path__ + "static/media/all-medias_ico.0bf7fb1a.svg";